export const state = () => ({
  doctorList: [],
  otpDetails: {},
  rootpage: '',
  loginLoading: false,
  callLoading:false
});
